import { Injectable } from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../../services/base.service';
import {Observable} from 'rxjs';
import {Panel} from '../models/panel';
import {Slider} from '../models/slider';

@Injectable({
  providedIn: 'root'
})
export class PanelService extends BaseService {

  httpOptions;

  constructor(private authService: AuthService, private httpClient: HttpClient) {
    super();

  }
  // get panels list
  public getPanels(): Observable<Panel[]> {

    return this.httpClient.get<Panel[]>(`${this.apiURL}/vpanels`, {
      headers: this.authService.getHttpOptions()
    });

  }

  // get panel by id
  public getPanelByID(id): Observable<Panel> {

    return this.httpClient.get<Panel>(`${this.apiURL}/vpanels/` + id, {
      headers: this.authService.getHttpOptions()
    });

  }

  // get panel by code
  public getPanelByCode(code): Observable<Panel> {

    return this.httpClient.get<Panel>(`${this.apiURL}/vpanels/bycode/` + code, {
      headers: this.authService.getHttpOptions()
    });

  }



  // update panel
  public updatePanel(panel) {

    return this.httpClient.put<any>(`${this.apiURL}/vpanels` , panel ,  {
      headers: this.authService.getHttpOptions()
    });

  }

  // create panel
  public createPanel(panel) {

    return this.httpClient.post<any>(`${this.apiURL}/vpanels` , panel ,  {
      headers: this.authService.getHttpOptions()
    });

  }

  // delete panel by id
  public removePanel(id): Observable<Panel> {

    return this.httpClient.delete<Panel>(`${this.apiURL}/vpanels` + id, {
      headers: this.authService.getHttpOptions()
    });

  }

  // add products to panel
  public addProductToPanel(panel) {

    return this.httpClient.post<any>(`${this.apiURL}/vpanels/product/add` , panel ,  {
      headers: this.authService.getHttpOptions()
    });

  }

  // delete panel product by id , sku
  public removePanelProducts(id , sku): Observable<any> {

    const obj = {
      'vpanel_id': id,
      'product_sku': sku
    };

    return this.httpClient.post<any>(`${this.apiURL}/vpanels/product/remove` , obj ,  {
      headers: this.authService.getHttpOptions()
    });

  }


}
